module.exports = __webpack_public_path__ + "static/media/healthy.f475db27.jpg";